import { createFileRoute } from "@tanstack/react-router";
import NearshoringVsOffshoring from "@/pages/NearshoringVsOffshoring";

export const Route = createFileRoute("/en/nearshoring-vs-offshoring-vs-outsourcing")({
  component: NearshoringVsOffshoring,
});
